
<div class="d-flex flex-column justify-content-between" style="padding-top: 2.5em;height: 100%">

  <div class="d-flex justify-content-between align-items-center px-3">
    <div>
      <p class="date-info-result-flight-weekday" style="text-transform: capitalize;">Sale el {{getDateInfo('departureWeekDay')}}</p>
      <p class="date-info-result-flight-hour">{{getDateInfo('departureInitial') | date: 'HH:mm'}}</p>
      <p class="date-info-result-flight-city">{{getDateInfo('departureCity')}}</p>
      <p class="date-info-result-flight-iata">{{getDateInfo('departureAirportIata')}}</p>
    </div>
    <div class="d-flex flex-column align-items-center">
      <p class="date-info-result-flight-duration">{{getDateInfo('durationFlight')}}</p>
      <p class="date-info-result-flight-segment">{{getDateInfo('segmentQty')}}</p>

      <div class="d-flex align-items-center" style="width: 100%; margin-top: 10px; gap: 6px">
        <div style="height: 1px; border-bottom: 1px solid #cccccc; flex: 1;width: 75px;"></div>
        <img src="../../../../../../../../assets/icons/itinerary/vuelo_vert.svg" style="width: 18px;transform: rotate(90deg); flex-shrink: 0; margin: 0 6px;" alt="">
        <div style="height: 1px; border-bottom: 1px solid #cccccc; flex: 1;width: 75px;"></div>
      </div>

      <p class="date-info-result-flight-class">{{ getDateInfo('class') }}</p>
    </div>
    <div class="d-flex flex-column align-items-end">
      <p class="date-info-result-flight-weekday" style="text-transform: capitalize;">Llega el {{getDateInfo('arrivalDestinationWeekDay')}}</p>
      <p class="date-info-result-flight-hour">{{getDateInfo('arrivalDestination') | date: 'HH:mm'}}</p>
      <p class="date-info-result-flight-city">{{getDateInfo('arrivalDestinationCity')}}</p>
      <p class="date-info-result-flight-iata">{{getDateInfo('arrivalDestinationAirportIata')}}</p>
    </div>
  </div>

  <div class="d-flex py-2 px-3" style="border-top: .5px solid #cccccc; height: 67px">
      <p class="mb-1 rubik-regular-12pt" style="font-weight: 600;color: black;">
          N/A
        </p>
  </div>

</div>



